'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Base = require('../Base');

var _Base2 = _interopRequireDefault(_Base);

var _GaUniversal = require('./GaUniversal');

var _GaUniversal2 = _interopRequireDefault(_GaUniversal);

var _GaClassic = require('./GaClassic');

var _GaClassic2 = _interopRequireDefault(_GaClassic);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright (c) 2017, Shopgate, Inc. All rights reserved.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * This source code is licensed under the Apache 2.0 license found in the
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * LICENSE file in the root directory of this source tree.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

var TRACK_PAGE_VIEW = 'pageView';
var TRACK_EVENT = 'event';
var TRACK_SET = 'set';
var TRACK_REQUIRE = 'require';
var TRACK_CONVERSION = {
  ADDITEM: 'addItem',
  CURRENCY: 'currencyCode',
  END: 'trackTrans',
  START: 'addTrans'
};

var ACCOUNT_CLASSIC = 'classic';
var ACCOUNT_UNIVERSAL = 'universal';

var shopgateOnly = {
  merchant: false,
  shopgate: true
};

var merchantOnly = {
  merchant: true,
  shopgate: false
};

// Command mapping tuple, [classic, universal]
var commandMapping = {};
commandMapping[TRACK_PAGE_VIEW] = ['trackPageview', 'pageview'];
commandMapping[TRACK_EVENT] = ['trackEvent', 'event'];
commandMapping[TRACK_SET] = ['set'];
commandMapping[TRACK_CONVERSION.ADDITEM] = ['addItem', 'ecommerce:addItem'];
commandMapping[TRACK_CONVERSION.CURRENCY] = ['currencyCode'];
commandMapping[TRACK_CONVERSION.END] = ['trackTrans', 'ecommerce:send'];
commandMapping[TRACK_CONVERSION.START] = ['addTrans', 'ecommerce:addTransaction'];
commandMapping[TRACK_REQUIRE] = [undefined, 'require'];

/**
 * Parent Tracking plugin for Google Analytics
 */

var GaBase = function (_BasePlugin) {
  _inherits(GaBase, _BasePlugin);

  /**
   * Constructor
   */
  function GaBase() {
    _classCallCheck(this, GaBase);

    // Universal and classic merchant and shopgate accounts
    var _this = _possibleConstructorReturn(this, (GaBase.__proto__ || Object.getPrototypeOf(GaBase)).call(this, 'GAcore', {}));

    _this.accounts = [];

    _this.isRegistered = false;

    _this.universalPlugin = null;
    _this.classicPlugin = null;
    return _this;
  }

  /**
   * Returns common data for a custom event
   * @param {string} name Event category
   * @param {Object} data Input
   * @returns {{
   *   eventCategory: (string),
   *   eventAction: (string),
   *   eventLabel: (null|string),
   *   eventValue: (null|number),
   *   nonInteraction: (boolean)
   * }}
   * @private
   */


  _createClass(GaBase, [{
    key: 'sendCommand',


    /**
     * Send command to both universal and classic sdk
     *
     * @param {string} command Name of the command
     * @param {Object|Array|string|Function} [payload] Data for the command,
     *   or a function that returns data
     * @param {Object} [scope] Scope (merchant or shopgate account)
     * @param {string} [account] Which account to use, classic or universal
     * @private
     */
    value: function sendCommand(command, payload, scope, account) {
      if (typeof commandMapping[command] === 'undefined') {
        console.warn('SgGATracking: Unknown google analytics command "' + command + '"');
        return;
      }

      // Evaluate which accounts to send to.
      var isClassic = typeof account === 'undefined' || account === ACCOUNT_CLASSIC;
      var isUniversal = typeof account === 'undefined' || account === ACCOUNT_UNIVERSAL;

      if (isUniversal && this.universalPlugin !== null) {
        this.universalPlugin.send(commandMapping[command][1], payload, scope);
      }
      if (isClassic && this.classicPlugin !== null) {
        this.classicPlugin.send(commandMapping[command][0], payload, scope);
      }
    }

    /**
     * Helper to register for some events
     * @private
     */

  }, {
    key: 'registerEvents',
    value: function registerEvents() {
      var _this2 = this;

      if (this.isRegistered) {
        return;
      }

      this.isRegistered = true;

      // Handle pageview event for shopgate accounts
      this.register.pageview(function (data) {
        _this2.sendCommand(TRACK_PAGE_VIEW, data.page.shopgateUrl, shopgateOnly);
      }, shopgateOnly);

      // Handle pageview event for merchant account
      this.register.pageview(function (data) {
        _this2.sendCommand(TRACK_PAGE_VIEW, data.page.merchantUrl, merchantOnly);
      }, merchantOnly);

      // Handle add_to_cart event as a pageview
      this.register.addToCart(function () {
        _this2.sendCommand(TRACK_PAGE_VIEW, 'add_to_cart');
      });

      // Smart app banner
      this.register.smartbanner(function (data) {
        _this2.sendCommand(TRACK_EVENT, GaBase.getEventData('Smartbanner', data));
      });

      // Scroll to top button event
      this.register.scrollTop(function (data) {
        _this2.sendCommand(TRACK_EVENT, GaBase.getEventData('ScrollTop', data), shopgateOnly);
      });

      // Qr scanner events
      this.register.qrScanner(function (data) {
        _this2.sendCommand(TRACK_EVENT, GaBase.getEventData('QRScanner', data));
      });

      // Ad scanner events
      this.register.adScanner(function (data, originalData, scope) {
        _this2.sendCommand(TRACK_EVENT, GaBase.getEventData('AdScanner', data), scope);
      });

      // Credit card scanner events
      this.register.ccScanner(function (data) {
        _this2.sendCommand(TRACK_EVENT, GaBase.getEventData('CcScanner', data));
      });

      // Filter in live suggest events
      this.register.filterLiveSuggest(function (data) {
        _this2.sendCommand(TRACK_EVENT, GaBase.getEventData('FilterLiveSuggest', data), shopgateOnly);
      });

      // Deeplink
      this.register.openDeepLink(function (data) {
        _this2.sendCommand(TRACK_EVENT, GaBase.getEventData('DeepLinkOpen', data), shopgateOnly);
      });

      // Universal link
      this.register.openUniversalLink(function (data) {
        _this2.sendCommand(TRACK_EVENT, GaBase.getEventData('UniversalLinkOpen', data), shopgateOnly);
      });

      // Deferred deep link
      this.register.openDeferredDeepLink(function (data) {
        _this2.sendCommand(TRACK_EVENT, GaBase.getEventData('DeferredDeepLinkOpen', data), shopgateOnly);
      });

      // Smart app download link
      this.register.openSmartAppDownloadLink(function (data) {
        _this2.sendCommand(TRACK_EVENT, GaBase.getEventData('SmartAppDownloadLink', data), shopgateOnly);
      });

      // Push notification
      this.register.openPushNotification(function (data) {
        _this2.sendCommand(TRACK_EVENT, GaBase.getEventData('PushNotification', data), shopgateOnly);
      });

      // App review prompt
      this.register.appReviewPrompt(function (data) {
        _this2.sendCommand(TRACK_EVENT, GaBase.getEventData('AppReviewPrompt', data), shopgateOnly);
      });

      // Purchase events
      this.register.purchase(function (data, rawData) {
        _this2.sendCommand('require', ['ecommerce', 'ecommerce.js'], null, ACCOUNT_UNIVERSAL);

        _this2.sendCommand(TRACK_CONVERSION.START, function (account) {
          return {
            amountCompleteFloat: account.useNetPrices ? data.revenueNet : data.revenueGross,
            amountTaxCompleteFloat: data.tax,
            amountShippingFloat: account.useNetPrices ? data.shippingNet : data.shippingGross,
            city: rawData.order.shippingAddress.city,
            countryId: rawData.order.shippingAddress.country,
            currency: data.currency,
            orderNumber: data.id,
            shopName: data.affiliation,
            state: rawData.order.shippingAddress.stateId || ''
          };
        });

        data.items.forEach(function (item) {
          _this2.sendCommand(TRACK_CONVERSION.ADDITEM, function (account) {
            return {
              orderNumber: rawData.order.number,
              productNumber: item.id,
              name: item.name,
              quantity: item.quantity,
              unitAmount: account.useNetPrices ? item.priceNet : item.priceGross
            };
          });
        });

        _this2.sendCommand(TRACK_SET, [TRACK_CONVERSION.CURRENCY, data.currency], null, ACCOUNT_CLASSIC);

        _this2.sendCommand(TRACK_CONVERSION.END);
      });

      // Opt-out
      this.register.removeTracker(function () {
        _this2.sendCommand(TRACK_EVENT, GaBase.getEventData('analyticsOptOut', {
          eventAction: 'optOut',
          eventLabel: 'all_accounts'
        }));

        _this2.accounts.forEach(function (account) {
          var disableStr = 'ga-disable-' + account.id;
          document.cookie = disableStr + '=true; expires=Thu, 31 Dec 2099 23:59:59 UTC; path=/';
          window[disableStr] = true;
        });
      });

      // Revert opt-out
      this.register.addTracker(function () {
        _this2.accounts.forEach(function (account) {
          var disableStr = 'ga-disable-' + account.id;
          document.cookie = disableStr + '=false; expires=Thu, 01 Jan 1970 00:00:01 UTC; path=/';
          window[disableStr] = false;
        });

        _this2.sendCommand(TRACK_EVENT, GaBase.getEventData('revertOptOut', {
          eventAction: 'optOut',
          eventLabel: 'all_accounts'
        }));
      });
    }

    /**
     * Creates an ga universals child tracker
     * @param {Object} tracker Tracker configuration data
     * @returns {GaUniversal} plugin instance
     */

  }, {
    key: 'createUniversal',
    value: function createUniversal(tracker) {
      var _accounts;

      (_accounts = this.accounts).push.apply(_accounts, _toConsumableArray(tracker.config.merchant).concat([tracker.config.shopgate]));

      this.universalPlugin = new _GaUniversal2.default(tracker);
      this.registerEvents();
      return this.universalPlugin;
    }

    /**
     * Creates a ga classic child tracker
     * @param {Object} tracker Tracker configuration data
     * @returns {GaClassic} plugin instance
     */

  }, {
    key: 'createClassic',
    value: function createClassic(tracker) {
      var _accounts2;

      (_accounts2 = this.accounts).push.apply(_accounts2, _toConsumableArray(tracker.config.merchant));

      this.classicPlugin = new _GaClassic2.default(tracker);
      this.registerEvents();
      return this.classicPlugin;
    }
  }], [{
    key: 'getEventData',
    value: function getEventData(name, data) {
      return {
        eventCategory: name,
        eventAction: data.eventAction,
        eventLabel: data.eventLabel,
        eventValue: data.eventValue,
        nonInteraction: data.nonInteraction
      };
    }
  }]);

  return GaBase;
}(_Base2.default);

// Export and create global instance


window.SgGATrackingInstance = new GaBase();

exports.default = window.SgGATrackingInstance;


// WEBPACK FOOTER //
// ./~/@shopgate/tracking-core/plugins/trackers/GaBase.js